import { initializeApp } from 'firebase/app';
import {getAuth,getIdTokenResult,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut,} from 'firebase/auth'
    import {
      getFirestore,
      query,
      getDocs,
      collection,
      where,
      getDoc,
      doc,
      setDoc,
      deleteDoc,
      addDoc,
      orderBy,
      serverTimestamp
    } from "firebase/firestore";
    import { getFunctions, httpsCallable } from "firebase/functions";
    


const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId:  process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
    appId:  process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID
  };
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const db = getFirestore(app);
  
  
  
  const logInWithEmailAndPassword = async (email, password) => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };
  const registerWithEmailAndPassword = (name, email, password) => {
    return createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
       const data = {
        uid:userCredential.user.uid,
        email:email,
        displayName:name,
        role:'user',
        createdOn:Date.now()
       };
      var docRef = doc(db,"users",data.uid);
      setDoc(docRef,data).catch(err=>console.log(err));
      return 'Signed Up!';
      })
      .catch((err) => {
        return err;
      });
  };
  const updateDocument=(collection,docId,data,merge)=>{
    try {
      var wrappedData =Object.assign(data,{lastModified:new Date().toUTCString()});
      console.log('wrapped data',wrappedData);
      var docRef = doc(db,collection,docId);
      return setDoc(docRef,wrappedData,{merge:merge});
    } catch (error) {
      return error;
    }

    }
  const sendPasswordReset = async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset link sent!");
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  const addComment = async ({ postId, userId, displayName, text }) => {
    if (!postId || !text) throw new Error("postId and text are required");
    const comment = {
      postId,
      userId: userId || null,
      displayName: displayName || "Guest",
      text,
      created: serverTimestamp(),
    };
    const ref = await addDoc(collection(db, "comments"), comment);
    return { id: ref.id, ...comment, created: new Date() };
  };

  const getCommentsForPost = async (postId) => {
    if (!postId) return [];
    const commentsRef = collection(db, "comments");
    const q = query(commentsRef, where("postId", "==", postId), orderBy("created", "asc"));
    const snap = await getDocs(q);
    return snap.docs.map((d) => {
      const data = d.data();
      return {
        id: d.id,
        ...data,
        created: data.created?.toDate ? data.created.toDate() : null,
      };
    });
  };
  const logout = () => {
    signOut(auth);
  };
  const doSignInWithEmailAndPassword = (auth,email, password) =>{
    return signInWithEmailAndPassword(auth,email, password);
  
  }
  async function getUser(uid){
    console.log(uid);
    const docRef = doc(db, "users", uid);
    const docSnap = await getDoc(docRef);
    const data = docSnap.data();
  return data;
  }
  
  async function getNFTs(){
    let payload = [];
                const nftsRef = collection(db, 'nfts');
                const q =query(nftsRef,where('assetId','>',0));
             await getDocs(q).then((querySnapshot)=>{
                      querySnapshot.forEach((doc) => {
                        if(doc.exists){
                            var data = doc.data();
                            payload.push(data);
                          }
                      });
              });
            
  
    return payload;
    }

    async function getNFTCollection(collectionName){
      let payload = [];
                  const nftsRef = collection(db, 'nfts');
                  const q =query(nftsRef,where('collectionName','==',collectionName));
               await getDocs(q).then((querySnapshot)=>{
                        querySnapshot.forEach((doc) => {
                          if(doc.exists){
                              var data = doc.data();
                              payload.push(data);
                            }
                        });
                });
              
    
      return payload;
      }

    async function getWorkOrders(){
      let payload = [];
                  const nftsRef = collection(db, 'work-orders');
                  const q =query(nftsRef,where('assetId','>',0));
               await getDocs(q).then((querySnapshot)=>{
                        querySnapshot.forEach((doc) => {
                          if(doc.exists){
                              var data = doc.data();
                              payload.push(data);
                            }
                        });
                });
              
    
      return payload;
      }
      async function getSecureConfigByUID(uid){
        try {
          const docRef = doc(db, "secure-config", uid);
          const docSnap = await getDoc(docRef);
          if(docSnap.exists){
            return docSnap.data();
          }else{
            let doc ={uid,nftStorageApiKey:'',PinataAPISecret:'',lastModified:new Date().toUTCString()};
            updateDocument("secure-config",uid,doc,true)
            return doc;
          }
        } catch (error) {
          return {message:error};
        }
      
      }

      async function getAllPosts() {
   
        let payload = [];
        const posts = collection(db, 'posts');
        const q = query(posts, where('published', '==', true));
        await getDocs(q).then((querySnapshot) => {
          if(!querySnapshot.empty){
              querySnapshot.forEach((doc) => {
                          if (doc.exists) {
                            var data = doc.data();
                            payload.push(data);
                          }
                        });
          }else{
            console.log("No Results")
          }
        });
        return payload;
      }
       async function getAllPages() {
   
        let payload = [];
        const posts = collection(db, 'pages');
        const q = query(posts);
        await getDocs(q).then((querySnapshot) => {
          if(!querySnapshot.empty){
              querySnapshot.forEach((doc) => {
                          if (doc.exists) {
                            var data = doc.data();
                            payload.push(data);
                          }
                        });
          }else{
            console.log("No Results")
          }
        });
        return payload;
      }
  const doCreatePage=(page)=>{
        if(!page.id)return;
        console.log(page);
        return db.collection("pages").doc(page.id).set(page).then(()=>{
          console.log('Page created successfully!');
         }).catch(err=>{
           console.error(err);
           console.error(err);
         });
         
      }

      const doCreatePost=(post)=>{
        if(!post.id)return;
        console.log(post);
        return db.collection("posts").doc(post.id).set(post).then(()=>{
          console.log('Draft created successfully!');
         }).catch(err=>{
           console.error(err);
           console.error(err);
         });
         
      }
      const doPublishPost = post =>{
        if(!post)return;
        var newDoc = Object.assign({},post, {
            isDraft:false,
            published:true,
            publishedOn:new Date(),
            lastUpdate:new Date()
          });
        return this.firestore.collection("posts").doc(post.id).set(newDoc,{merge:true});
      }
    
     const  doUpdatePost = post => {
        console.log(this.auth.currentUser.uid);
        if (!post || !post.id) return "Document Id was not present.";
        var ref = this.firestore.collection("posts").doc(post.id);
        return ref
          .set(post)
          .then(function() {
            console.log("Post updated");
            console.info("Post updated!",{position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true});
           
          })
          .catch(function(error) {
            console.error("Error updating document: ", error);
            console.error("Rat-patootie!! there was an issue..");
    
          });
      };
    
      const deleteDocument = async (docId,collectionName) => {
        try {
          console.log('Delete Doc:',docId)
          const docRef = doc(db, collectionName, docId);
          await deleteDoc(docRef);
          console.log("Document deleted successfully");
        } catch (error) {
          console.error("Error deleting document: ", error);
        }
      };
    
    
      async function getPosts(uid) {
        let payload = [];
        const posts = collection(db, 'posts');
        const q = query(posts, where('author', '==', uid));
        await getDocs(q).then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.exists) {
              var data = doc.data();
              // Exclude the 'lastSaveDate' property from the data
              delete data.lastSaveDate;
              delete data.lastUpdate;
              delete data.publishedOn;
              payload.push(data);
            }
          });
        });
        return payload;
      }
      const getDocument = async (collectionName, docId) => {
        try {
          const docRef = doc(db, collectionName, docId);
          const docSnap = await getDoc(docRef);
          return docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : null;
        } catch (error) {
          console.error(`Error fetching document ${docId} from ${collectionName}:`, error);
          throw error;
        }
      };
      export const getBlogPostById = async (blogId) => {
        try {
          const docRef = doc(db, "posts", blogId);
          const docSnap = await getDoc(docRef);
          
          if (docSnap.exists()) {
            return { id: docSnap.id, ...docSnap.data() };
          } else {
            console.error("No such document!");
            return null;
          }
        } catch (error) {
          console.error("Error fetching blog post:", error);
          return null;
        }
      };
       export const getPageById = async (pageId) => {
        try {
          const docRef = doc(db, "pages", pageId);
          const docSnap = await getDoc(docRef);
          
          if (docSnap.exists()) {
            return { id: docSnap.id, ...docSnap.data() };
          } else {
            console.error("No such document!");
            return null;
          }
        } catch (error) {
          console.error("Error fetching blog post:", error);
          return null;
        }
      };
  export const handleAssignAdmin = async (email)=>{
    const functions = getFunctions(undefined, "us-central1"); // ✅ Specify region
const assignAdminRole = httpsCallable(functions, "assignAdminRole");
   if (!email) return false;
  const user = auth.currentUser;
  if (!user) {
    console.error("You must be signed in to assign admin roles.");
    return false;
  }
    try {
      const idTokenResult = await getIdTokenResult(user);
     // const isAdmin = idTokenResult.claims.admin;
    //  console.error("You must be an admin to assign admin roles.");
  
  
      const result = await assignAdminRole({ email });
      console.log("Success:", result.data);
      return false;
    } catch (err) {
      console.error(err);
    }
      }

  export {
    auth,
    db,
    getIdTokenResult,
    logInWithEmailAndPassword,
    registerWithEmailAndPassword,
    sendPasswordReset,
    logout,
    doSignInWithEmailAndPassword,
    getUser,
    updateDocument,
    getNFTs,
    getWorkOrders,
    getNFTCollection,
    getSecureConfigByUID,
    getAllPosts,
    getDocument,
    doCreatePost,
    deleteDocument,
    doPublishPost,
    doUpdatePost,
    getPosts,
    doCreatePage,
    getAllPages,
    addComment,
    getCommentsForPost
  };
